<template>
  <div class="vipmapping">
    <NodeNav></NodeNav>
    <div class="diy-service-wrap">
      <div class="diy-service">
        <div class="back" @click="goBack">
          <div class="back-icon"></div>
          手动添加服务
        </div>
        <!-- <div class="diy-title">手动添加服务</div> -->
        <!-- <div class="diy-item">
          <div class="diy-text">选择内网</div>
          <div class="device-list-wrap">
            <div
              :class="{
                'select-icon': true,
                'select-icon2': isShowDeviceList,
              }"
              @click="switchClick"
            ></div>
            <div class="device-list" v-if="isShowDeviceList">
              <div
                class="device-item"
                v-for="(item, index) in list"
                :key="index"
                @click="itemClick(item, index)"
              >
                {{
                  item.term.comment
                    ? item.term.comment
                    : item.term.name
                    ? item.term.name
                    : item.peerid
                }}
              </div>
            </div>
            <div class="item-text" v-if="JSON.stringify(item) != '{}'">
              {{
                item.term.comment
                  ? item.term.comment
                  : item.term.name
                  ? item.term.name
                  : item.peerid
              }}
            </div>
            <div
              class="item-text"
              v-if="!isShowDeviceList && JSON.stringify(item) == '{}'"
            >
              在所选设备的局域网中创建服务
            </div>
          </div>
        </div> -->
        <div class="diy-item">
          <div class="diy-text">服务类型</div>
          <div class="diy-select-wrap">
            <div
              class="diy-select-item"
              :class="{ active: type == item.type }"
              @click="changeType(item.type)"
              :key="item.type"
              v-for="item in types"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <template v-if="type == 'service'">
          <div class="diy-item">
            <div class="diy-text">服务名称</div>
            <div class="diy-input-wrap">
              <input placeholder="请输入服务名称" type="text" v-model="name" />
            </div>
          </div>
          <div class="diy-item">
            <div class="diy-text">服务IP</div>
            <div class="diy-input-wrap">
              <input placeholder="请输入内网IP" type="text" v-model="ip" />
            </div>
          </div>
          <div class="diy-item">
            <div class="diy-text">服务端口</div>
            <div class="diy-input-wrap diy-input-wrap2">
              <input placeholder="请输入端口" type="number" v-model="port" />
            </div>
          </div>
          <div class="btns">
            <div class="btn" @click="goBack">取消</div>
            <div class="btn btn2" @click="addClick">添加服务</div>
          </div>
        </template>
        <template v-if="type == 'wakeup'">
          <div class="diy-item">
            <div class="diy-text">设备名称</div>
            <div class="diy-input-wrap">
              <input
                placeholder="请输入设备名称"
                type="text"
                v-model="macName"
              />
            </div>
          </div>
          <div class="diy-item">
            <div class="diy-text">设备MAC</div>
            <div class="diy-input-wrap">
              <input placeholder="请输入设备MAC" type="text" v-model="mac" />
            </div>
          </div>
          <div class="diy-item" style="height: 42px"></div>
          <div class="btns">
            <div class="btn" @click="goBack">取消</div>
            <div class="btn btn2" @click="addWakeupClick">添加服务</div>
          </div>
        </template>
        <!-- <div class="btn" @click="addClick">创建</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NodeNav from "@/components/Node/NodeNav.vue";
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
export default {
  components: {
    Nav,
    HomeNav,
    NodeNav,
  },
  data: function () {
    return {
      list: [],
      type: "service",
      types: [
        {
          name: "自定义服务",
          type: "service",
        },
        {
          name: "远程开机",
          type: "wakeup",
        },
      ],
      isShowDeviceList: false,
      item: {},
      name: "",
      macName: "",
      mac: "",
      ip: "",
      port: "",
    };
  },
  methods: {
    ...mapActions([
      "bindget",
      "nodelistmanset",
      "checkBindList",
      "nodelistset",
    ]),
    changeType: function (type) {
      this.type = type;
    },
    goBack: function () {
      this.$router.back(-1);
    },
    addWakeupClick: function () {
      let _that = this;
      if (JSON.stringify(_that.item) == "{}") {
        _that.$store.state.toast = "请选择设备内网";
        return;
      }

      if (!_that.macName) {
        _that.$store.state.toast = "请输入设备名称";
        return;
      }

      if (!_that.mac) {
        _that.$store.state.toast = "请输入设备MAC";
        return;
      }

      if (_that.mac.length <= 0) {
        _that.addTips = "请输入设备MAC";
        return;
      }
      _that.mac = _that.mac.toUpperCase();
      _that.mac = _that.mac.replace(/：/g, ":");
      _that.mac = _that.mac.replace(/\ /g, "");
      if (_that.mac.indexOf(":") < 0) {
        _that.mac = _that.changeMac(_that.mac);
      }
      if (!_that.isMac(_that.mac)) {
        _that.addTips = "MAC地址错误";
        return;
      }
      // if (!_that.$common.isValidIP(_that.ip)) {
      //   _that.$store.state.toast = "请输入正确的服务IP地址";
      //   return;
      // }

      // if (!_that.port) {
      //   _that.$store.state.toast = "请输入服务端口";
      //   return;
      // }
      // _that.port = parseInt(_that.port);

      // if (_that.port < 1 || _that.port > 65536) {
      //   _that.$toast("请输入正确的端口：1~65536");
      //   return;
      // }

      let port = 10000 + parseInt(Math.random() * 45000);

      let addArr = [];
      let mac = _that.mac.replace(/:/g, "");
      addArr.push({
        host: "127.0.0.1",
        port: port,
        name: _that.macName,
        mac: mac,
        dtype: 998,
      });
      _that.nodelistmanset([
        _that.item.peerid,
        addArr,
        function (err, data) {
          if (!err && !data.rtn) {
            _that.$store.state.toast = "添加成功";
            _that.goBack();
          } else {
            _that.$toast("添加失败:" + data.rtn);
          }
        },
      ]);
    },

    isMac: function (mac) {
      var temp =
        /[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}:[A-Fa-f0-9]{2}/;
      if (!temp.test(mac)) {
        return false;
      }
      return true;
    },

    changeMac: function (str) {
      let length = 2;
      var reg = new RegExp("\\w{1," + length + "}", "g");
      let ma = str.match(reg);
      return ma.join(":");
    },

    addClick: function () {
      let _that = this;
      if (JSON.stringify(_that.item) == "{}") {
        _that.$store.state.toast = "请选择设备内网";
        return;
      }

      if (!_that.name) {
        _that.$store.state.toast = "请输入服务名称";
        return;
      }

      if (!_that.ip) {
        _that.$store.state.toast = "请输入服务IP";
        return;
      }
      if (!_that.$common.isValidIP(_that.ip)) {
        _that.$store.state.toast = "请输入正确的服务IP地址";
        return;
      }

      if (!_that.port) {
        _that.$store.state.toast = "请输入服务端口";
        return;
      }
      _that.port = parseInt(_that.port);

      if (_that.port < 1 || _that.port > 65536) {
        _that.$toast("请输入正确的端口：1~65536");
        return;
      }

      let addArr = [];
      addArr.push({
        host: _that.ip,
        port: _that.port,
        name: _that.name,
        dtype: 999,
      });
      _that.nodelistmanset([
        _that.item.peerid,
        addArr,
        function (err, data) {
          if (!err && !data.rtn) {
            _that.$store.state.toast = "添加成功";
            _that.goBack();
          } else {
            _that.$toast("添加失败:" + data.rtn);
          }
        },
      ]);
    },

    itemClick: function (data) {
      let _that = this;
      _that.item = data;
      _that.isShowDeviceList = false;
    },
    switchClick: function () {
      let _that = this;
      _that.isShowDeviceList = !_that.isShowDeviceList;
    },
    getBindget: function () {
      let _that = this;
      //用户是否有绑定设备
      _that.checkBindList([
        false,
        function (err, list) {
          _that.item = _that.$store.state.curDev;
        },
      ]);
    },
  },
  activated: function () {
    let _that = this;
    _that.getBindget();
    _that.name = "";
    _that.ip = "";
    _that.port = "";
  },
};
</script>
<style lang="less" scoped>
.diy-service-wrap {
  background-color: #f2f5fa;
  //   width: 960px;
  //   height: 426px;
  overflow: hidden;
}
.diy-service {
  margin: 0 auto;
  //   width: 940px;
  //   height: 418px;
  box-sizing: border-box;
  border-radius: 4px;
  // background-image: url("../../assets/vip/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #ffffff;
  //   border: 1px solid #e8c29b;
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  overflow: hidden;
  .back {
    display: inline-block;
    line-height: 35px;
    font-size: 14px;
    color: #666666;
    margin-bottom: -20px;
    margin-top: 15px;
    margin-left: 20px;
    cursor: pointer;
    border-radius: 20px;
    background: #f1edff;
    padding-right: 20px;
    .back-icon {
      display: inline-block;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 0px;
      vertical-align: top;
      width: 16px;
      height: 16px;
      background-image: url("../../assets/vip/back.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .diy-title {
    margin-top: 35px;
    margin-bottom: 35px;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    color: #1a1a1a;
    text-align: center;
  }
  .diy-select-wrap {
    display: inline-block;
    vertical-align: top;
    .diy-select-item {
      width: 94px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #a3a3a3;
      background: #fff;
      display: inline-block;
      vertical-align: top;
      color: #a3a3a3;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      margin-top: 6px;
      margin-right: 8px;
    }
    .diy-select-item:hover,
    .active {
      border: 1px solid #615ef8;
      background: #e6dfff;
      color: #5e49df;
      cursor: pointer;
    }
  }
  .diy-item {
    margin-top: 20px;
    .device-list-wrap {
      position: relative;
      display: inline-block;
      vertical-align: top;
      line-height: 42px;
      width: 264px;
      height: 42px;
      background-color: #fcfdff;
      border: 1px solid #cbcdd1;
      border-radius: 48px;
      box-sizing: border-box;
      .select-icon {
        position: absolute;
        top: -1px;
        right: 20px;
        width: 24px;
        height: 42px;
        background-image: url("../../assets/vip/open.svg");
        background-repeat: no-repeat;
        background-size: 13px 7px;
        background-position: center;
        cursor: pointer;
      }
      .select-icon2 {
        transform: rotate(180deg);
        transition: transform 0.3s ease-in-out;
      }
      .device-list {
        position: absolute;
        z-index: 1;
        top: 46px;
        right: -1px;
        width: 264px;
        height: 158px;
        background-color: #ffffff;
        box-shadow: 0px 0px 6px rgba(73, 80, 90, 0.2);
        border-radius: 8px;
        overflow-y: scroll;
        .device-item {
          position: relative;
          padding-left: 24px;
          height: 42px;
          width: 100%;
          box-sizing: border-box;
          color: #999999;
          cursor: pointer;
        }
        .device-item::after {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
          content: "";
          width: 216px;
          height: 1px;
          background-color: #cbcdd1;
        }

        .device-item:hover {
          background-color: #eef0f5;
          color: #2b3f7f;
        }
      }
      .item-text {
        margin-left: 20px;
        font-size: 14px;
        color: #999999;
      }
    }
    .diy-text,
    .diy-input-wrap {
      display: inline-block;
      vertical-align: top;
      line-height: 42px;
    }
    .diy-text {
      margin-left: 250px;
      margin-right: 15px;
      width: 130px;
      color: #666666;
      font-size: 16px;
      text-align: right;
    }
    .diy-input-wrap {
      position: relative;
      width: 200px;
      height: 42px;
      background-color: #faf8ff;
      border: 1px solid #cbcdd1;
      border-radius: 48px;
      box-sizing: border-box;
      overflow: hidden;
      input {
        padding-left: 24px;
        width: 100%;
        height: 100%;
        background-color: transparent;
        color: #666666;
        font-size: 15px;
      }
    }
    .diy-input-wrap2 {
      //   width: 136px;
    }
    .diy-input-wrap:hover {
      //   background-color: #ffffff;
    }
  }
  .btn {
    margin: 0 auto;
    width: 186px;
    height: 48px;
    line-height: 48px;
    background: linear-gradient(156deg, #2f4386 27%, #1b3065 82%);
    box-shadow: 0px 4px 8px rgba(43, 48, 57, 0.2);
    border-radius: 120px;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }
  .btn:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  .btns {
    text-align: center;
    margin-top: 30px;
    .btn {
      display: inline-block;
      vertical-align: top;
      width: 156px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      color: #1a1f9f;
      background: linear-gradient(
        189deg,
        rgba(108, 105, 254, 0.2) 0%,
        rgba(76, 73, 236, 0.2) 35.94%,
        rgba(41, 67, 157, 0.2) 99.24%
      );
      box-shadow: 0px -2px 3px 0px rgba(35, 72, 106, 0.21) inset;
      border-radius: 200px;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
    }
    .btn2 {
      margin-left: 24px;
      background-color: #29439d;
      background-image: linear-gradient(
        189deg,
        #6c69fe 0%,
        #4c49ec 35.94%,
        #29439d 99.24%
      );
      color: #ffffff;
    }
  }
}
</style>